import cloneDeep from 'lodash/cloneDeep';
import uniqBy from 'lodash/uniqBy';
import { PromiseStatus } from '../enums/PromiseStatus';
import { router } from '../router';
import { appService } from '../services/AppService';
import { hirService } from '../services/HirService';
import { projektService } from '../services/ProjektService';
import { userService } from '../services/UserService';
import settings from '../settings';
import store from '../store';
import { AppStoreTypes } from '../store/modules/app';
import { GetParameterByName, isDarkColor } from '../utils/common';
import { sortBool, sortStr, sortWith } from '../utils/sort';
import { deleteToken } from '../utils/token';
import { NotificationFunctions } from './NotificationFunctions';
import vuetify from '../plugins/vuetify';

class AppFunctions {
  async GetInitData() {
    await userService.GetUser();
    await appService.GetSzervezetek();
    await hirService.GetKategoriak();
    await projektService.GetLinkek();
  }

  HandleParams() {
    let bottomBar = GetParameterByName('bottomBar');
    if (!settings.isProd) {
      bottomBar = true;
    }
    this.SetAppData('bottomBar', bottomBar ? true : false);
  }
  SetAppData(prop, value) {
    let data = this.GetAppData();
    data[prop] = value;
    store.dispatch(AppStoreTypes.appSettings.set, { value: data });
  }
  GetAppData() {
    return cloneDeep(store.getters[AppStoreTypes.appSettings.get]) || {};
  }
  async GetFooldalAdatok() {
    let data = await Promise.allSettled([
      hirService.GetHirek({}),
      hirService.GetAktivSzerzok(),
      hirService.GetNepszeruHirek({}),
      hirService.GetVezerHir(),
      hirService.GetYoutubeVideok(),
    ]);
    let dataKeys = {
      topHirek: 0,
      aktivSzerzok: 1,
      nepszeruHirek: 2,
      youtubeVideok: 4,
    };
    let errors = [];
    let vezerHir = [];
    if (data[3].status == PromiseStatus.Fulfilled) {
      vezerHir = data[3].value;
    } else {
      errors.push(data[3].reason);
    }
    let result = { vezerHir };
    for (const dataKey in dataKeys) {
      if (Object.hasOwnProperty.call(dataKeys, dataKey)) {
        const dataIndex = dataKeys[dataKey];
        let promise = data[dataIndex];
        if (promise.status == PromiseStatus.Fulfilled) {
          result[dataKey] = uniqBy(promise.value, 'Id');
        } else {
          result[dataKey] = [];
          errors.push(promise.reason);
        }
      }
    }
    store.dispatch(AppStoreTypes.fooldalData.set, { value: result });
    if (errors.length > 0) {
      for (var e in errors) console.log(errors[e]);
      NotificationFunctions.AjaxError({ error: errors[0] });
    }
    return result;
  }
  async GetFooldalDesktopAdatok(keresoParameterek) {
    let data = await Promise.allSettled([
      hirService.GetHirekLapozhato({
        kategoriaId: keresoParameterek.kategoriaId,
        szerzoId: keresoParameterek.szerzoId,
        oldal: keresoParameterek.oldal,
      }),
      hirService.GetAktivSzerzok(300),
      hirService.GetNepszeruHirekLapozhato({}),
      hirService.GetVezerHir(),
      hirService.GetYoutubeVideok(),
    ]);
    let dataKeys = {
      topHirek: 0,
      aktivSzerzok: 1,
      nepszeruHirek: 2,
      youtubeVideok: 4,
    };
    let errors = [];
    let vezerHir = [];
    if (data[3].status == PromiseStatus.Fulfilled) {
      vezerHir = data[3].value;
    } else {
      errors.push(data[3].reason);
    }
    let result = { vezerHir };
    for (const dataKey in dataKeys) {
      if (Object.hasOwnProperty.call(dataKeys, dataKey)) {
        const dataIndex = dataKeys[dataKey];
        let promise = data[dataIndex];
        if (promise.status == PromiseStatus.Fulfilled) {
          result[dataKey] = promise.value;
        } else {
          result[dataKey] = [];
          errors.push(promise.reason);
        }
      }
    }
    store.dispatch(AppStoreTypes.fooldalDataDesktop.set, { value: result });
    if (errors.length > 0) {
      for (var e in errors) console.log(errors[e]);
      NotificationFunctions.AjaxError({ error: errors[0] });
    }
    return result;
  }
  Kijelentkezes() {
    deleteToken();
    router.push({ name: 'NoPermission' });
    if (global.SNJS) {
      global.SNJS.logout();
    }
  }
  GetAlkategoriakFromKategoriak(hirKategoriak) {
    let alkategoriak = hirKategoriak.reduce((prevValue, currValue) => {
      prevValue.push(...currValue.Kategoria);
      return prevValue;
    }, []);
    alkategoriak.sort(sortStr('Nev'));
    return alkategoriak;
  }
  SortSzerzok(szerzok, user) {
    let aktivSzerzok = cloneDeep(szerzok);
    let userSzervezetId = user?.Szervezet?.Id;
    aktivSzerzok.forEach(szerzo => {
      szerzo.isUserSzervezet = false;
      if (szerzo.Id == userSzervezetId) {
        szerzo.isUserSzervezet = true;
      }
    });
    sortWith(aktivSzerzok, sortBool('isUserSzervezet'), sortStr('Nev'));
    return aktivSzerzok;
  }
  GetBgColorStyle(user) {
    let aktualisProjekt = user?.Projekt;
    if (!aktualisProjekt) {
      return {};
    }
    let szin1 = aktualisProjekt.Hatterszin1;
    let szin2 = aktualisProjekt.Hatterszin2;

    if (szin1 && szin2) {
      return {
        background: `linear-gradient(180deg, ${szin1} 0%, ${szin2} 100%)`,
      };
    }

    return { background: szin1 };
  }
  GetNyelvesitesDict(nyelvesites) {
    if (!nyelvesites) {
      return {};
    }
    let dict = {};

    nyelvesites.forEach(szoveg => {
      dict[szoveg.Kulcs] = szoveg.Szoveg;
    });
    return dict;
  }
  SetApplicationTheme(color) {
    let isDark = isDarkColor(color);
    if (isDark) {
      vuetify.framework.theme.isDark = true;
    } else {
      vuetify.framework.theme.isDark = false;
    }
  }
}

let instance = new AppFunctions();
export { instance as AppFunctions };
